module.exports = __webpack_public_path__ + "static/img/img4.daa12bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img4.png
// module id = yfxx
// module chunks = 1